import React from 'react';
import classnames from 'classnames';
import styles from './FloSearchBox.module.css';
import { FloComponentProps } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface FloSearchBoxProps extends FloComponentProps {
  value:        string;
  placeholder:  string;
  onChange:     (newValue: string) => void;
}

export const FloSearchBox: React.FC<FloSearchBoxProps> = React.memo(({className, value, placeholder, onChange}) => {
  return (
    <div className = {classnames(styles.root, className)}>
      <FontAwesomeIcon className={styles.icon} icon="search" />
      <input
        className   = {styles.input}
        type        = "text"
        placeholder = {placeholder}
        value       = {value}
        onChange    = {(event) => {
          onChange(event.target.value)
        }}
      />
    </div>
  );
})

export default FloSearchBox;